import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BlogApiService } from '../services/blog-api.service';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.css']
})
export class BlogDetailsComponent {

  blogContent: any;

  constructor(@Inject(DOCUMENT) private document: Document, private blogApiService: BlogApiService, private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');

    
    let slug = this.route.snapshot.paramMap.get('slug');

    if (slug != null) {

      this.blogApiService.getBlogPost(slug).subscribe(content => {

        this.blogContent = content;
        this.titleService.setTitle(this.blogContent.title +" | RankAhead");

      })
    }


  }
}
